export default "__VITE_ASSET__jNbKMlfW__"